import { CONFIG } from 'ui-utilities';
import { PLATFORM } from '../constants/SiteVariables';
import { isEmpty } from 'lodash';

export const uploadImagesToCloudinary = image => {
  return (dispatch, getState) => {
    const { plan } = getState();
    const url = `https://api.cloudinary.com/v1_1/${CONFIG.CLOUDINARY_NAME}/image/upload`;

    if(!image || image === '') {
      if(plan.get('photos').length > 0 && plan.get('instagram_photos').length > 0) {
        var images = plan.get('instagram_photos').concat(plan.get('photos'));
      } else if(plan.get('photos').length > 0) {
        images = plan.get('photos')
      } else if(plan.get('instagram_photos').length > 0){
        images = plan.get('instagram_photos');
      }
    } else {
      images = [image];
    }

    if(images && !isEmpty(images)) {
      return Promise.all(images
        .map(i => new Promise((resolve, reject) => {
          let data = new FormData();
          let xhr = new XMLHttpRequest();
          data.append('file', i);
          data.append('upload_preset', CONFIG.CLOUDINARY_PRESET)
          data.append('folder', PLATFORM('platform') !== 'production' ? 'vendor_uploads/' + PLATFORM('platform') : 'vendor_uploads');

          xhr.onload = () => {
            if(xhr.status === 200) {
              let jsonData = JSON.parse(xhr.responseText);
              resolve(jsonData.secure_url)
            } else {
              reject(({status: xhr.status, text: xhr.statusText}))
            }
          }

          xhr.open('POST', url, true);
          xhr.send(data);
      })))
    }

    return Promise.resolve([]);
  }
}



// WEBPACK FOOTER //
// ./src/actions/cloudinary.js